// utils/dateUtils.js

const PERSIAN_WEEKDAYS = ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه', 'شنبه'];

const PERSIAN_MONTHS = [
    'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور',
    'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'
];

export function getCurrentPersianDate() {
    const now = new Date();
    
    // تلاش برای استفاده از Intl (سریع و دقیق)
    try {
        const formatter = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
            weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
        });
        const parts = formatter.formatToParts(now);
        
        let weekday = '', day = '', month = '', year = '';
        for (const part of parts) {
            if (part.type === 'weekday') weekday = part.value;
            else if (part.type === 'day') day = part.value;
            else if (part.type === 'month') month = part.value;
            else if (part.type === 'year') year = part.value;
        }
        
        if (weekday && day && month && year) {
            return `${weekday} ${day} ${month} ${year}`;
        }
    } catch {
        // fallback به متد دستی
    }
    
    // fallback دستی
    const weekday = PERSIAN_WEEKDAYS[(now.getDay() + 1) % 7];
    const jalali = toJalali(now);
    return `${weekday} ${jalali.day} ${PERSIAN_MONTHS[jalali.month - 1]} ${jalali.year}`;
}

function toJalali(date) {
    const gYear = date.getFullYear();
    const gMonth = date.getMonth() + 1;
    const gDay = date.getDate();
    
    const gDaysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    const jDaysInMonth = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];
    
    const gy = gYear - 1600;
    const gm = gMonth - 1;
    let gd = gDay - 1;
    
    let gDayNo = 365 * gy + Math.floor((gy + 3) / 4) - Math.floor((gy + 99) / 100) + Math.floor((gy + 399) / 400);
    for (let i = 0; i < gm; i++) {
        gDayNo += gDaysInMonth[i];
    }
    if (gm > 1 && ((gYear % 4 === 0 && gYear % 100 !== 0) || (gYear % 400 === 0))) {
        gDayNo++;
    }
    gDayNo += gd;
    
    let jDayNo = gDayNo - 79;
    const jNp = Math.floor(jDayNo / 12053);
    jDayNo %= 12053;
    let jy = 979 + 33 * jNp + 4 * Math.floor(jDayNo / 1461);
    jDayNo %= 1461;
    
    if (jDayNo >= 366) {
        jy += Math.floor((jDayNo - 1) / 365);
        jDayNo = (jDayNo - 1) % 365;
    }
    
    let jm = 0;
    for (let i = 0; i < 11 && jDayNo >= jDaysInMonth[i]; i++) {
        jDayNo -= jDaysInMonth[i];
        jm++;
    }
    
    return { year: jy, month: jm + 1, day: jDayNo + 1 };
}